import React from "react";
import demoImage from "../../Assets/Images/about_bg.png";

const AboutSection = () => {
  return (
    <section className="w-full bg-white px-4 md:px-10">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 md:gap-10">
        {/* Left Side - Image */}
        <div className="relative">
          <div className="relative overflow-hidden rounded-lg h-64 sm:h-80 md:h-full">
            <img
              src={demoImage}
              alt="Mechanic at work"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Right Side - Text */}
        <div className="space-y-4 md:space-y-6">
          <p className="text-[#E8471B] font-montserrat font-medium text-lg sm:text-xl leading-[24px] tracking-[0.5px] capitalize mt-4">
            About Us
          </p>
          <h2 className="font-orbitron text-[#030B25] font-semibold text-2xl sm:text-3xl md:text-4xl xl:text-[45px] leading-[130%] tracking-[1px] capitalize w-full xl:w-[75%]">
            Manika Automotive at your service
          </h2>
          <p className="font-montserrat text-[#3E3E3E] font-normal text-base sm:text-lg md:text-[18px] leading-[24px] tracking-[1%]">
            At Manika Automotive Service, we specialize in delivering reliable,
            high-quality automotive care across a wide range of services —
            including car denting and painting, mechanical repairs, brake
            servicing, oil changes, and much more.
          </p>

          {/* Point 1 */}
          <div className="mb-3">
            <p className="font-montserrat font-semibold text-lg sm:text-xl leading-[24px] tracking-[0.5px] capitalize text-[#030B25]">
              <span role="img" aria-label="wrench">
                🔧
              </span>{" "}
              Advanced Diagnostics, Trusted Expertise
            </p>
            <p className="font-montserrat font-normal text-base sm:text-lg md:text-[18px] leading-[24px] tracking-[1%] text-[#3E3E3E] mt-3">
              Our workshops are equipped with modern diagnostic tools that
              reduce troubleshooting time and improve service accuracy.
            </p>
          </div>

          {/* Point 2 */}
          <div>
            <p className="font-montserrat font-semibold text-lg sm:text-xl leading-[24px] tracking-[0.5px] capitalize text-[#030B25]">
              <span role="img" aria-label="car">
                🚗
              </span>{" "}
              Quality Service For Every Vehicle
            </p>
            <p className="mt-3 font-montserrat font-normal text-base sm:text-lg md:text-[18px] leading-[24px] tracking-[1%] text-[#3E3E3E]">
              We guarantee high-quality service at affordable prices for all
              types of vehicles. From basic servicing to detailed mechanical
              work, we treat every car with care.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
